import React, { useState } from 'react';
import { Alert, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../translations';
import {
  CreateEmailResendDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useNotifications } from '../../../common/hooks/useNotifications';

import {
  canResendEmail,
  emailResendFromDateText,
} from './emailResendAvailability';

export const EmailResendLink = (props: {
  emailId: string;
  sendDate?: Date;
  setRefresh?: () => void;
  setLoading?: (loading: boolean) => void;
}) => {
  const { t, tk } = useTranslation('applicationLng');
  const pok = usePokCore();
  const notifications = useNotifications();

  const [showModal, setShowModal] = useState(false);

  const resendAllowed = canResendEmail(props.sendDate);

  const handleResend = () => {
    if (!resendAllowed) {
      return;
    }
    if (props.setLoading) {
      props.setLoading(true);
    }
    const resendDto: CreateEmailResendDto = { id: props.emailId };
    pok.emails
      .resend(resendDto)
      .then(() => {
        if (props.setRefresh) {
          props.setRefresh();
        }
        if (props.setLoading) {
          props.setLoading(false);
        }
        setShowModal(false);
      })
      .catch(error => {
        notifications.caughtError(error as ResponseError);
        if (props.setLoading) {
          props.setLoading(false);
        }
      });
  };

  return (
    <>
      <Button
        variant="link"
        className="ms-1"
        onClick={() => setShowModal(true)}
      >
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              {t(tk.email.resendEmail)}
            </Tooltip>
          }
        >
          <Icon.ArrowClockwise size={18} />
        </OverlayTrigger>
      </Button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>{t(tk.email.resendEmail)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {resendAllowed ? (
            t(tk.email.resendEmailQuestion)
          ) : (
            <Alert variant="warning" className="mb-0">
              {t(tk.email.resendNotAvailableBeforeDate, {
                date: emailResendFromDateText(),
              })}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
          >
            {t(tk.button.cancel)}
          </Button>
          {resendAllowed && (
            <Button variant="outline-primary" onClick={handleResend}>
              {t(tk.button.send)}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
